export default "__VITE_ASSET__a9bd7a62__"